module.exports = __webpack_public_path__ + "static/hero-mobile.f22a49cc.webp";